import React, { useState } from "react";

import Tab from "react-bootstrap/Tab";
import Dropdown from "react-bootstrap/Dropdown";
// import Nav from "react-bootstrap/Nav";

import "./ExpandedPlaylistTabSwitcher.css";

import {
  PlaylistPostsSortedByLatest,
  PlaylistPostsSortedByRank,
} from "./ExpandedPlaylistLoadingLists";

import { Playlist_SortOrder } from "../../API";

export interface ExpandedPlaylistTabSwitcherConfig {
  postCollectionId: string;
  defaultSortOrder: Playlist_SortOrder | undefined;
}

const keyLatest = "first";
const keyInOrder = "second";
function _tabName(tabKey: string | null): string {
  if (tabKey === keyLatest) {
    return "Latest-first";
  }
  if (tabKey === keyInOrder) {
    return "In-order";
  } else {
    return "Unknown";
  }
}

export function ExpandedPlaylistTabSwitcher(
  props: ExpandedPlaylistTabSwitcherConfig
): JSX.Element {
  let initialSelectedKey = keyLatest;
  if (props.defaultSortOrder) {
    if (props.defaultSortOrder === Playlist_SortOrder.LATEST) {
      initialSelectedKey = keyLatest;
    } else if (props.defaultSortOrder === Playlist_SortOrder.CUSTOM) {
      initialSelectedKey = keyInOrder;
    }
  }

  const [selectedKey, setSelectedKey] = useState(
    initialSelectedKey as string | null
  );

  return (
    <div>
      {/* <hr style={{ marginBottom: 0 }} /> */}
      <Tab.Container
        id="left-tabs-example"
        activeKey={selectedKey || undefined}
        onSelect={(k) => setSelectedKey(k)}
      >
        <div className="DropDownContainer">
          <Dropdown>
            <Dropdown.Toggle size="lg">{`Sort: ${_tabName(
              selectedKey
            )}`}</Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item eventKey={keyLatest}>
                {_tabName(keyLatest)}
              </Dropdown.Item>
              <Dropdown.Item eventKey={keyInOrder}>
                {_tabName(keyInOrder)}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <Tab.Content>
          <Tab.Pane eventKey={keyLatest}>
            {PlaylistPostsSortedByLatest(props.postCollectionId)}
          </Tab.Pane>
          <Tab.Pane eventKey={keyInOrder}>
            {PlaylistPostsSortedByRank(props.postCollectionId)}
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  );
}
